export default {
  fi: {
    SideBar: {
      logOut: 'Kirjaudu ulos',
      home: 'Vikailmoitukset',
    },
  },
};
